const data = [
    {
        id: 1,
        title: "Mount Fuji",
        location: "Japan",
        googleMapsUrl: "https://goo.gl/maps/1DGM5WrWnATgkSNB8",
        startDate: "12 Jan, 2021",
        endDate: "24 Jan, 2021",
        description: "Mount Fuji is the tallest mountain in Japan, standing at 3,776 meters (12,380 feet). Mount Fuji is the single most popular tourist site in Japan, for both Japanese and foreign tourists.",
        imageUrl: "https://images.unsplash.com/photo-1578637387939-43c525550085?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
    },
    {
        id: 2,
        title: "Sydney Opera House",
        location: "Australia",
        googleMapsUrl: "https://goo.gl/maps/XuX38YRxkeLeVfku9",
        startDate: "27 May, 2021", 
        endDate: "8 June, 2021",
        description: "The Sydney Opera House is a multi-venue performing arts centre in Sydney. Located on the banks of the Sydney Harbour, it is often regarded as one of the 20th century's most famous and distinctive buildings.",
        imageUrl: "https://images.unsplash.com/photo-1616128618694-96e9e896ecb7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1590&q=80"
    },
    {   
        id: 3,
        title: "Geirangerfjord",
        location: "Norway",
        googleMapsUrl: "https://goo.gl/maps/ji3ntsSKNsQBMyzz7",
        startDate: "01 Oct, 2021", 
        endDate: "18 Nov, 2021",
        description: "The Geiranger Fjord is a fjord in the Sunnmøre region of Møre og Romsdal county, Norway. It is located entirely in the Stranda Municipality.",
        imageUrl: "https://images.unsplash.com/photo-1576537506631-f68d90fc1b5c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1666&q=80"
    }
]

export default data